const ACKO_MEDS = {
    "Biotin": "Biotin",
    "Multivitamin": "Multivitamin",
    "CoQ10": "CoQ10",
    "Omega 3": "Omega 3",
    "Myo:D Chiro Inositol": "Myo:D Chiro Inositol",
    "Prebiotic + Probiotic": "Prebiotic + Probiotic",
    "DHT Blocker": "DHT Blocker",
    "Triphala": "Triphala",
    "Calcium with D3 Complex": "Calcium with D3 Complex",
    "Vit B12": "Vit B12",
    "Calcium with Growth Nutrients": "Calcium with Growth Nutrients",
    "B Complex with Antioxidants": "B Complex with Antioxidants",
    "DHA (age 8-14 yrs)": "DHA (age 8-14 yrs)",
    "Garlic Odourless Capsules": "Garlic Odourless Capsules",
    "Magnesium Complex with Zinc": "Magnesium Complex with Zinc",
    "Ashwagandha": "Ashwagandha",
    "Vitamin B12": "Vitamin B12",
    "L-Carnitine + Chromium Picolinate": "L-Carnitine + Chromium Picolinate"
}

const ACKO_PRODUCTS = [
    {
        name: "Women's Hair & Skin Nourish",
        id: "women-hair-skin-nourish",
        persona: "Women (age 25-50),general wellness and routine hair/skin care",
        medicines: [ACKO_MEDS.Biotin, ACKO_MEDS.Multivitamin]
    },
    {
        name: "Reproductive Health Essentials",
        id: "reproductive-health-essentials",
        persona: "Women (age 25-35),concerns with fertility, hormonal changes",
        medicines: [ACKO_MEDS.CoQ10, ACKO_MEDS.Multivitamin]
    },
    {
        name: "PCOS Support Pack",
        id: "pcos-support-pack",
        persona: "Women (child bearing age) seeking PCOS support",
        medicines: [ACKO_MEDS["Myo:D Chiro Inositol"], ACKO_MEDS.Multivitamin]
    },
    {
        name: "Gut Health & Skin Glow",
        id: "gut-health-skin-glow",
        persona: "Women (age 25-50),facing gut concerns, severe skin and hair problems",
        medicines: [ACKO_MEDS["Prebiotic + Probiotic"], ACKO_MEDS.Multivitamin]
    },
    {
        name: "Men's Heart & Daily Health",
        id: "men-heart-daily-health",
        persona: "Men (age 25-50), general wellness, cardiac protection",
        medicines: [ACKO_MEDS["Omega 3"], ACKO_MEDS.Multivitamin]
    },
    {
        name: "Hair & Scalp Wellness",
        id: "hair-scalp-wellness",
        persona: "Men (age 25-50),seeking support for hair loss/ balding",
        medicines: [ACKO_MEDS["DHT Blocker"], ACKO_MEDS["Omega 3"]]
    },
    {
        name: "Immunity & Gut Support",
        id: "immunity-gut-support",
        persona: "Men (age 25-50), having increased proneness to infection and gut imbalance",
        medicines: [ACKO_MEDS["Prebiotic + Probiotic"], ACKO_MEDS.Multivitamin, ACKO_MEDS["Triphala"]]
    },
    {
        name: "Menopause Wellness Support",
        id: "menopause-wellness-support",
        persona: "Women (age 50+),menopausal/post menopausal. Facing hormonal imbalance, gut concerns and osteoporotic changes",
        medicines: [ACKO_MEDS["Calcium with D3 Complex"], ACKO_MEDS["Prebiotic + Probiotic"]]
    },
    {
        name: "50+ Nerve & Vitality Boost",
        id: "50-nerve-vitality-boost",
        persona: "Men( age 50+) seeking vitality,cardiac care,bone care and heightened nerve sensitivity",
        medicines: [ACKO_MEDS["Calcium with D3 Complex"], ACKO_MEDS["Omega 3"], ACKO_MEDS["Vit B12"]]
    },
    {
        name: "Kids' Growth & Brain Boost",
        id: "kids-growth-brain-boost",
        persona: "Children (age 8-15),to support adequate growth, brain development and function",
        medicines: [ACKO_MEDS["Calcium with D3 Complex"], ACKO_MEDS["DHA (age 8-14 yrs)"]]
    },
    {
        name: "Gut Relief & Digestive Care",
        id: "gut-relief-digestive-care",
        persona: "Individuals with severe gut imbalance,characherised by constipation/diarrhoea/freq indigestion episodes",
        medicines: [ACKO_MEDS["Prebiotic + Probiotic"], ACKO_MEDS["Garlic Odourless Capsules"]]
    },
    {
        name: "Calm & Sleep Support",
        id: "calm-sleep-support",
        persona: "Individuals who face severe sleep issues and are stressed",
        medicines: [ACKO_MEDS["Magnesium Complex with Zinc"], ACKO_MEDS.Ashwagandha]
    },
    {
        name: "Bone & Muscle Strength",
        id: "bone-muscle-strength",
        persona: "Individuals looking to strengthen bones, improve muscle function and growth",
        medicines: [ACKO_MEDS["Calcium with D3 Complex"], ACKO_MEDS.Multivitamin]
    },
    {
        name: "Glucose & Metabolic Balance",
        id: "glucose-metabolic-balance",
        persona: "Individuals with Diabetes/Insulin Resistance",
        medicines: [ACKO_MEDS["Omega 3"], ACKO_MEDS.Multivitamin]
    },
    {
        name: "Heart Health & Cholesterol Care",
        id: "heart-health-cholesterol-care",
        persona: "Individuals with dyslipidemia/Hypertension, looking for cardiac function",
        medicines: [ACKO_MEDS["Omega 3"], ACKO_MEDS["Magnesium Complex with Zinc"]]
    },
    {
        name: "Brain & Memory Support",
        id: "brain-memory-support",
        persona: "Men and women (age 35+) looking specifically to improve memory, brain function and nerve sensitivity",
        medicines: [ACKO_MEDS["Omega 3"], ACKO_MEDS["Vitamin B12"]]
    },
    {
        name: "Metabolism Boost & Weight Control",
        id: "metabolism-boost-weight-control",
        persona: "Fat management category.Individuals with a slow metabolism, increased cravings and stubborn fat ",
        medicines: [ACKO_MEDS["L-Carnitine + Chromium Picolinate"], ACKO_MEDS.Multivitamin]
    },
    {
        name: "Recovery & Strength Essentials",
        id: "recovery-strength-essentials",
        persona: "Fitness enthusiasts,with daily intense workout involving resistance training,seeking good muscle recovery and growth",
        medicines: [ACKO_MEDS["Magnesium Complex with Zinc"], ACKO_MEDS["Omega 3"], ACKO_MEDS.Multivitamin]
    },
]

const ackoContants = {
    ACKO_MEDS,
    ACKO_PRODUCTS
}

export default ackoContants